export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes/";
export const API_KEY = "6c3a46e2-cf1b-4ad6-a375-c97742425fca";
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const MODAL_CLOSE_SEC = 2.5;
